import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <div id="contact" className="main bgc">
      <h1> This is the contact section!</h1>
    </div>
  );
}

export default Contact;
